export const MessageType = {
  UNKNOWN_TYPE: 'UNKNOWN_TYPE',
  CONF_INFO: 'CONF_INFO',
  CONNECT_STATUS: 'CONNECT_STATUS',
  REALTIME_DATA: 'REALTIME_DATA',
  STEERING_OPERATE: 'STEERING_OPERATE',
};

export const BASIC_INFO = 'BASIC_INFO';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const VIDEO_URL = 'VIDEO_URL'; // 批量获取视频播放地址
export const SYNC_ANDRIOD_CONNECT_STATUS = 'SYNC_ANDRIOD_CONNECT_STATUS'; // 安卓在线情况反馈
export const SYNC_OPERATION = 'SYNC_OPERATION'; // 安卓操作同步
export const GET_GEAR_POSITION = 'GET_GEAR_POSITION'; // 安卓请求挡位信息
export const SEND_GEAR_POSITION = 'SEND_GEAR_POSITION'; // 将挡位信息发送给安卓
export const SEND_VOICE_INTENT = 'SEND_VOICE_INTENT'; // 将障碍物意图发送给安卓
export const SCREEN_COCKPIT_TEAM = 'SCREEN_COCKPIT_TEAM'; // 驾舱团队信息
export const COCKPIT_TEAM = 'COCKPIT_TEAM'; // 驾舱团队信息
export const USER_INFO = 'USER_INFO'; // 用户信息
export const DRAWER_INFO = 'DRAWER_INFO'; //工单抽屉
export const COCKPIT_INFO = 'COCKPIT_INFO'; // 座席信息
export const MQTT_TOKEN = 'MQTT_TOKEN';
export const GetCockpitStatus = 'GetCockpitStatus'; // 获取座席状态
export const GET_ENUM_LIST_MAP = 'GET_ENUM_LIST_MAP'; // 获取枚举字段翻译
export const LOGIN_OUT = 'LOGIN_OUT';
export const SCREEN_COMMAND_RESULT = 'SCREEN_COMMAND_RESULT'; //指令结果
export const VEHICLE_TAKE_OVER_INFO = 'VEHICLE_TAKE_OVER_INFO'; // 接管/退出接管指令
export const EXIT_COCKPIT = 'EXIT_COCKPIT'; // 退出驾舱

